import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

import { InstrumentationData } from './instrumentation-data.model';
import { InstrumentationParam, InstrumentationService, KnownReferralPlatform } from './instrumentation.service';

@Directive({
    selector: '[ohpInstrumentClick]'
})
export class InstrumentClickDirective implements OnInit {
    @Input('ohpInstrumentClick') public clickData: InstrumentationData;

    constructor(
        private readonly instrumentationService: InstrumentationService,
        private readonly element: ElementRef
    ) {
    }

    @HostListener('click', ['$event'])
    public onClick(event: MouseEvent) {
        if (event.defaultPrevented || !this.clickData) {
            return;
        }

        const clickTargetId = this.clickData.params[InstrumentationParam.ElementId] as string || 'Unknown';
        const clickReferral = this.clickData.params[InstrumentationParam.Referral] as string;
        const clickArea = this.clickData.params[InstrumentationParam.Area] as string;

        this.instrumentationService.logClickEvent(this.clickData.eventName, clickTargetId, clickArea, clickReferral, KnownReferralPlatform.Web, this.clickData.params, this.clickData.metrics);
    }

    public ngOnInit() {
        // Prevent default click logging by assigning "data-clicklog=custom" attribute
        (this.element.nativeElement as HTMLElement).setAttribute('data-clicklog', 'custom');
    }
}
